import { useDisclose } from 'native-base'
import React, { createContext, ReactNode, useContext } from 'react'

type SubscriptionModalContextType = {
  onOpen: () => void
  onClose: () => void
  isOpen: boolean
}

const SubscriptionModalContext = createContext<SubscriptionModalContextType | undefined>(undefined)

type SubscriptionModalProviderProps = {
  children: ReactNode
}

export function SubscriptionModalProvider({ children }: SubscriptionModalProviderProps) {
  const disclosure = useDisclose()

  return <SubscriptionModalContext.Provider value={disclosure}>{children}</SubscriptionModalContext.Provider>
}

export function useSubscriptionModal() {
  const context = useContext(SubscriptionModalContext)
  if (context === undefined) {
    throw new Error('useSubscriptionModal must be used within a SubscriptionModalProvider')
  }
  return context
}
